<template>
  <div class="mt-3">
    <div class="border bg-white p-2 rounded-md">
      <PartialsTable :rows="data?.rows" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'league'
})

const league = useLeagueStore()

// Fetch table for league
const { data } = await useFetch(`/api/v1/leagues/${league.slug}/table`, {
  key: `league-${league.slug}-table`,
  baseURL: useEnv('apiBase')
})
</script>
